import { useContext, createContext } from 'react'

const PagePropsContext = createContext(null)
const Context = () => useContext(PagePropsContext)

export { PagePropsContext }
export default Context
